<template>
  <div class="">
    <div class="body-container">
      <ul class='circle-container'>
        <li>
          <a :href="links.dexpPortal" target="_blank">
            <img src='assets/Menu/DEXP-01.svg' alt="..." />
          </a>
        </li>
        <li>
          <a :href="links.projectInduction" target="_blank">
            <img src='assets/Menu/Project Induction.svg' alt="..." />
          </a>
        </li>
        <li>
          <a :href="links.projectDocuments" target="_blank">
            <img src='assets/Menu/MEETINGS AND WORKSHOPS-01.svg' alt="..." />
          </a>
        </li>
        <li>
          <a :href="links.contactList" target="_blank">
            <img src='assets/Menu/Contact List.svg' alt="..." />
          </a>
        </li>
        <li>
          <a :href="links.actionsList" target="_blank">
            <img src='assets/Menu/Actions List-01.svg' alt="..." />
          </a>
        </li>
        <li>
          <a :href="links.designPortal" target="_blank">
            <img src='assets/Menu/Design Portal-01.svg' alt="..." />
          </a>
        </li>
        <li>
          <a :href="links.projectManagementPlan" target="_blank">
            <img src='assets/Menu/Project Mgt Plan.svg' alt="..." />
          </a>
        </li>
        <li>
          <a :href="links.fileTransfer" target="_blank">
            <img src='assets/Menu/File Transfer.svg' alt="..." />

          </a>
        </li>
        <li>
          <img class="middle-circle" src='assets/Menu/loganleahub.png' alt="..." />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CircularContainer',
  data() {
    return {
      links: {
        communityPortal: "http://under-construction.geodemosolutions.com/",
        fileTransfer: "https://arcadiso365.sharepoint.com/teams/LoganleaHub/File%20Transfer/Forms/AllItems.aspx",
        projectInduction: "https://arcadiso365.sharepoint.com/teams/LoganleaHub/Project%20Induction/Forms/AllItems.aspx",
        projectDocuments: "https://arcadiso365.sharepoint.com/teams/LoganleaHub/Meetings/Forms/AllItems.aspx",
        contactList: "https://arcadiso365.sharepoint.com/teams/LoganleaHub/Lists/Contact%20List/AllItems.aspx",
        actionsList: "https://arcadiso365.sharepoint.com/teams/LoganleaHub/Lists/Action%20List/AllItems.aspx",
        designPortal: "https://au1gis.solutions.arcadis.com/arcgis/apps/MapSeries/index.html?appid=2f2fd491ab774daca1096ca069644a98",
        projectManagementPlan: "https://arcadiso365.sharepoint.com/teams/LoganleaHub/Project%20Management%20Plan/Forms/AllItems.aspx",
        lessonLearnedLibrary: "http://under-construction.geodemosolutions.com/",
        tfnswProjectPage: "http://under-construction.geodemosolutions.com/",
        inEightWebsite: "http://under-construction.geodemosolutions.com/",
        dexpPortal: "https://arcadiso365.sharepoint.com/teams/LoganleaHub/DEXP/Forms/AllItems.aspx"
      },
    }
  },
}
</script>

<style>
</style>
